import { RecordSharingApiInterface } from "@syadem/kairos-citizen-js";
import { Service } from "./service";
import { Success } from "../actionResult";

interface Payload {
  healthRecordId: string;
  email: string;
}

export class SendSharingTokenByMailService implements Service<Payload, null> {
  constructor(private readonly recordSharingApi: RecordSharingApiInterface) {}

  async call({ healthRecordId, email }: Payload): Promise<Success<null>> {
    await this.recordSharingApi.sendSharingTokenToCitizenByMail(healthRecordId, { email });

    return {
      type: "success",
      value: null,
    };
  }
}
